export function cleanupParams(params: string): string {
    return params.trim().replace(/['"`]+/g, '');
}